import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, Typography, Paper, Stack, IconButton } from "@mui/material";
import JsonView from "@uiw/react-json-view";
import { useFlags, camelCaseKeys } from "launchdarkly-react-client-sdk";

function copyJsonToClipboard(data: unknown) {
  if (!data) return;
  const jsonString = JSON.stringify(data, null, 2);

  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(jsonString).catch(() => {
      // do nothing
    });
  }
}

export const LaunchDarklyFlags = () => {
  const flags = camelCaseKeys(useFlags());

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, maxWidth: 800 }} elevation={2}>
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <Typography variant="h6" sx={{ mb: 0 }}>
            Launch Darkly Flags
          </Typography>
          {flags && typeof flags === "object" && (
            <IconButton
              aria-label="Copy Launch Darkly flags"
              size="small"
              onClick={() => copyJsonToClipboard(flags)}
            >
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          )}
        </Stack>
        {flags && typeof flags === "object" ? (
          <div role="region" aria-label="Launch Darkly flags details">
            <JsonView
              value={flags}
              displayDataTypes={false}
              enableClipboard={false}
              style={{
                fontSize: 16
              }}
              collapsed={1}
            />
          </div>
        ) : (
          <Typography color="text.secondary">No flags available.</Typography>
        )}
      </Paper>
    </Box>
  );
};
